import { render, staticRenderFns } from "./MiUnivisionarioNominado.vue?vue&type=template&id=3be84b17&"
import script from "./MiUnivisionarioNominado.vue?vue&type=script&lang=js&"
export * from "./MiUnivisionarioNominado.vue?vue&type=script&lang=js&"
import style0 from "./MiUnivisionarioNominado.vue?vue&type=style&index=0&id=3be84b17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports